export default __webpack_public_path__ + "static/media/scanner.0e3e9c71.svg";